<template>
	<div class="product-box">
		<div>
			<el-steps :active="step" finish-status="success" simple>
				<el-step title="选择商品" ></el-step>
				<el-step title="设置预售方案" ></el-step>
			</el-steps>
		</div>
		<div class="container-box"  v-show="step === 1">
			<div class="left-box">
				<div class="staff-name-box">
					<el-input v-model="cateName" size="mini" placeholder="请输入内容" @keyup.enter.native="cateSearch"></el-input>
					<el-button style="margin-left:10px" size="mini" type="primary" @click="cateSearch">查询</el-button>
				</div>
				<div class="tree-box">
					<el-tree
						ref="tree"
						:data="treeData"
						@check='checkChange'
						show-checkbox
						node-key="id"
						:props="defaultProps">
					</el-tree>
				</div>
			</div>
			<div class="right-box">
				<div class="staff-name-box">
					<el-input v-model="productName" size="mini" placeholder="请输入内容" @keyup.enter.native="proSearch"></el-input>
					<el-button style="margin-left:10px" size="mini" type="primary" @click="proSearch">查询</el-button>
				</div>
				<div class="tree-box">
					<el-table
						ref="table"
						:data="tableData"
						border
						style="width: 100%"
						height="300px"
						size='mini'
						@select="handleSelectionChange"
						@select-all="handleSelectionChange">
						<el-table-column
							type="selection"
							align="center"
							width="55">
						</el-table-column>
						<el-table-column
							prop="name"
							align="center"
							label="商品名称"
							min-width="120">
							<template slot-scope='scope'>
								<div style="display:flex;flex-direction: column;text-align: left;padding-left: 10px;">
									<div>{{scope.row.productName}}</div>
									<div>{{scope.row.productCode}}</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination
						style="text-align:center;margin-top:6px"
						@current-change="handlePageChange"
						:current-page="page"
						:page-sizes="[200]"
						:pager-count='5'
						:page-size="size"
						layout="total, prev, pager, next,jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<div v-show="step === 2" class="container-box1">
			<div class="row-box">
				<div style="min-width:150px">
					设置预售价格：
				</div>
				<el-radio style="min-height: 40px;;line-height: 40px;" v-model="priceType" :label="0">按原价增加</el-radio>
				<el-input style="width:100px;" v-model="upNum" @blur="upNumBlur" @input="upNumCheck" size="mini"></el-input>%
				<el-radio style="min-height: 40px;line-height: 40px;margin-left:50px" v-model="priceType" :label="1">原价下降</el-radio>
				<el-input style="width:100px" v-model="downNum" @blur="downNumBlur" @input="downNumCheck" size="mini"></el-input>%
			</div>
			<div class="row-box" style="color:#EE4F31">备注：最终计算后的价格进行“四舍五入”，与系统参数设置无关！</div>
			<div class="row-box">
				<div style="min-width:150px">
					设置预售数量：
				</div>
				<el-radio style="min-height: 40px;;line-height: 40px;" v-model="numType" :label="0">上限值</el-radio>
				<el-input @input='checkNum' @blur="blurNum" style="width:100px;margin-right:10px" v-model="maxNum" size="mini"></el-input>
				<el-radio style="min-height: 40px;;line-height: 40px;" v-model="numType" :label="1">不限</el-radio>
			</div>
			<div class="row-box" style="color:#EE4F31">备注：此处预售数量需要按系统参数设置支持输入小数位数！</div>
		</div>
		<div style="width: 100%;height: 50px;text-align: right;">
			<el-button v-if="step === 1" @click='closeClick' size='mini'>取消</el-button>
			<el-button v-if="step === 1" @click='stepClick("next")' size='mini' type="primary">下一步</el-button>
			<el-button v-if="step === 2" @click='stepClick("last")' size='mini'>上一步</el-button>
			<el-button v-if="step === 2" @click='saveClick' size='mini' type="primary">确定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'bindProduct',
	props: {
		chooseProAll: Array,
		decimal: Number
	},
	data () {
		return {
			priceType: 0,
			numType: 0,
			maxNum: 0,
			upNum: 0,
			downNum: 0,
			total: 0,
			bigcategoryview: 0,
			productName: '',
			cateName: '',
			chooseKey: '',
			step: 1,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id',
				selectHandler: this.tableSelectUtilsHandler
			}),
			treeData: [],
			tableData: [],
			page: 1,
			size: 200,
			defaultProps: {
				children: 'sc',
				label: 'name'
			}
		}
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	created () {
		this.checkSmallCategory()
		this.getTree()
	},
	methods: {
		downNumCheck () {
			this.downNum = this.downNum.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.downNum = this.downNum.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.downNum = this.downNum.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.downNum = this.downNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		},
		downNumBlur () {
			if (this.downNum === '') {
				this.downNum = 0.00
			} else {
				if (+this.downNum > 100) {
					this.downNum = 100.00
				}
				this.downNum = this.$fxUtils.toFixedSHW(this.downNum, 2)
			}
		},
		upNumCheck () {
			this.upNum = this.upNum.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.upNum = this.upNum.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.upNum = this.upNum.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.upNum = this.upNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		},
		upNumBlur () {
			if (this.upNum === '') {
				this.upNum = 0.00
			} else {
				if (+this.upNum > 100) {
					this.upNum = 100.00
				}
				this.upNum = this.$fxUtils.toFixedSHW(this.upNum, 2)
			}
		},
		checkNum () {
			this.maxNum = this.maxNum.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.maxNum = this.maxNum.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.maxNum = this.maxNum.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.maxNum = this.maxNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				this.maxNum = this.maxNum.replace(/(^[0]|[^\d])/g, '')
				break
			case 1:
				this.maxNum = this.maxNum.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				this.maxNum = this.maxNum.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				this.maxNum = this.maxNum.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				this.maxNum = this.maxNum.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
		},
		blurNum () {
			if (this.maxNum === '' || this.maxNum === null || +this.maxNum === 0) {
				return false
			}
			this.maxNum = +this.maxNum
			if (this.maxNum > 10000 || this.maxNum === 10000) {
				switch (this.decimal) {
				case 0:
					this.maxNum = 9999
					break
				case 1:
					this.maxNum = 9999.9
					break
				case 2:
					this.maxNum = 9999.99
					break
				case 3:
					this.maxNum = 9999.999
					break
				case 4:
					this.maxNum = 9999.9999
					break
				}
			}
		},
		tableSelectUtilsHandler (row) {
			return {
				id: row.id
			}
		},
		handlePageChange (val) {
			this.page = val
			this.getTable()
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
			// })
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			// console.log(this.ids)
		},
		proSearch () {
			this.page = 1
			this.getTable()
		},
		cateSearch () {
			this.resetChecked()
			this.getTree()
		},
		checkChange (a, b) {
			// console.log(a, b)
			let arr = b.checkedKeys
			this.chooseKey = arr.join(',')
			this.proSearch()
		},
		resetChecked () {
			this.$refs.tree.setCheckedKeys([])
		},
		saveClick () {
			let params = {
				ids: this.ids,
				numType: this.numType,
				priceType: this.priceType,
				maxNum: this.maxNum,
				upNum: this.upNum,
				downNum: this.downNum
			}
			this.$emit('reloadPro', params)
		},
		closeClick () {
			this.$emit('update:productDialog', false)
		},
		stepClick (flag) {
			if (flag === 'next') {
				if (this.ids.length === 0) {
					this.$message.error('请选择商品')
					return false
				}
				this.step = 2
			} else {
				this.step = 1
			}
		},
		getTable () {
			let list = this.chooseProAll.map(item => {
				return item.productid
			})
			let arr = []
			if (list.length > 0) {
				arr = Array.from(new Set(list))
			}
			let params = {
				productName: this.productName,
				ids: arr.join(','),
				page: this.page,
				size: this.size
			}
			if (this.bigcategoryview === 1) {
				params.smallTypeCategorys = this.chooseKey
			} else {
				params.bigTypeCategorys = this.chooseKey
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/product/getProductInfo4Presale`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = res.data.recordList
					if (res.data.recordList !== null) {
						this.$nextTick(() => {
							this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
						})
					}
					this.total = res.data.recordCount
				}
			})
		},
		getTree () {
			let params = {
				name: this.cateName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/category/presale/get`,
				data: params
			}).then(res => {
				if (res.result) {
					let list = res.data
					let arr = []
					if (this.bigcategoryview === 0) {
						list.forEach(item => {
							let row = {
								id: item.id,
								name: item.name
							}
							arr.push(row)
						})
						this.treeData = arr
					} else {
						this.treeData = res.data
					}
					this.proSearch()
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.product-box{
	display: flex;
	flex-direction: column;
}
.container-box{
	width: 100%;
	height: 400px;
	margin-top: 10px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
.container-box1{
	width: 100%;
	height: 400px;
	margin-top: 10px;
	display: flex;
	flex-direction: column;
}
.row-box{
	height: 40px;
	display: flex;
	flex-direction: row;
	width: 80%;
	margin-left: 10%;
	align-items: center;
}
.staff-name-box{
	display:flex;
	align-items center;
	justify-content:center
	color :#999999;
	height :40px;
	position :relative
}

.left-box{
	padding: 10px;
	width: 400px;
	height: 100%;
	display :flex;
	flex-direction :column;
	box-sizing :border-box;
	border:1px solid #F9F9F9;
	.tree-box{
		flex:1;
		padding: 5px;
		overflow-y: auto;
	}
}
.title-box{
	display:flex;
	flex-direction :row;
	justify-content:space-between;
	align-items :center;
	.left{
		display:flex;
		flex-direction :row;
		align-items :center;
		height :30px;
	}
}
.content-box{
	display:flex;
	flex-direction :row;
	align-items :center;
	height :30px;
	padding-left:30px;
	box-sizing :border-box;
}
.right-box{
	box-sizing:border-box;
	padding :10px;
	width: 600px;
	height: 100%;
	overflow-y:auto;
	border:1px solid #F9F9F9;
	.content-box{
		justify-content :space-between
	}
}
</style>
